import axios from 'axios';
// import errors from '@/data/errors.json';
// TODO: Единый обработчик запросов axios в глобальных функциях

export default {
  state: {
    userAuth: null,
    user_notifications: {
      all: null,
      offers: null,
      invites: null, 
      messages: {
          chats: null,
          all: null
      },
    },
  },
  actions: {
    async deleteNotifsByChat({ commit }, notification) {
      commit('deleteNotifsByChat', notification);
    },
    async addMessageNotification({ commit }, notification) {
      commit('addMessageNotification', notification);
    },
    setNotifications({ commit }, notifications) {
      commit('setNotifications', notifications);
    },
    async notifications({ commit }) {
      await axios
      .post(`/api/notifications/main`)
      .then(response => {
          commit('setNotifications', response.data);
        })
        .catch(error => {
          throw error;
        });
    },
    clearNotifications({ commit }) {
      commit('clearNotifications');
    },
    async loginYandex({ dispatch, commit }, user) {
      let tokens = null;
      await axios
        .post(`/api/auth/yandex`, user)
        .then((response) => {
          let user = response.data.user;
          tokens = response.data.tokens;
          tokens.accessToken ? localStorage.setItem('token', tokens.accessToken) : '';
          tokens.refreshToken ? localStorage.setItem('refresh', tokens.refreshToken) : '';
          axios.defaults.headers.common['Authorization'] = tokens.accessToken;
          axios.defaults.headers.common['Refresh'] = tokens.refreshToken;
          if (user) {
            commit('setUserAuth', user);
            localStorage.setItem('user', JSON.stringify(user));
          }
        })
        .catch((error) => {
          dispatch('addError', { message: error.response.data });
          throw error;
        });
      return tokens;
    },
    async loginGoogleOAuth({ dispatch, commit }, g_user) {
      let tokens = null;
      await axios
        .post(`/api/auth/google`, g_user)
        .then((response) => {
          let user = response.data.user;
          tokens = response.data.tokens;
          tokens.accessToken ? localStorage.setItem('token', tokens.accessToken) : '';
          tokens.refreshToken ? localStorage.setItem('refresh', tokens.refreshToken) : '';
          axios.defaults.headers.common['Authorization'] = tokens.accessToken;
          axios.defaults.headers.common['Refresh'] = tokens.refreshToken;
          if (user) {
            commit('setUserAuth', user);
            localStorage.setItem('user', JSON.stringify(user));
          }
        })
        .catch((error) => {
          dispatch('addError', { message: error.response.data });
          throw error;
        });
      return tokens;
    },
    async remind({ dispatch, commit }, email) {
      let result = null;
      commit
      await axios
        .post(`/api/auth/remind`, {email})
        .then((response) => {
          result = response.data
        })
        .catch((error) => {
          dispatch('addError', { message: error.response.data });
          throw error;
        });
      return result;
    },
    
    async loginVK({ dispatch, commit }, formData) {
      let tokens = null;
      await axios
        .post(`/api/auth/vk`, formData)
        .then((response) => {
          let user = response.data.user;
          tokens = response.data.tokens;
          tokens.accessToken ? localStorage.setItem('token', tokens.accessToken) : '';
          tokens.refreshToken ? localStorage.setItem('refresh', tokens.refreshToken) : '';
          axios.defaults.headers.common['Authorization'] = tokens.accessToken;
          axios.defaults.headers.common['Refresh'] = tokens.refreshToken;
          if (user) {
            commit('setUserAuth', user);
            localStorage.setItem('user', JSON.stringify(user));
          }
        })
        .catch((error) => {
          dispatch('addError', { message: error.response.data });
          error.response.data === 'Этот аккаунт необходимо активировать, вы отправили вам на почту письмо активации. 😉'
            ? tokens = {error: 'activating'}
            : ''
        });
      return tokens;
    },
    async login({ dispatch, commit }, formData) {
      let result = null;
      await axios
        .post(`/api/auth/login`, formData)
        .then((response) => {
          let user = response.data.user;
          let tokens = response.data.tokens;
          result = tokens
          tokens.accessToken ? localStorage.setItem('token', tokens.accessToken) : '';
          tokens.refreshToken ? localStorage.setItem('refresh', tokens.refreshToken) : '';
          axios.defaults.headers.common['Authorization'] = tokens.accessToken;
          axios.defaults.headers.common['Refresh'] = tokens.refreshToken;
          if (user) {
            commit('setUserAuth', user);
            localStorage.setItem('user', JSON.stringify(user));
          }
        })
        .catch((error) => {
          dispatch('addError', { message: error.response.data });
          error.response.data === 'Этот аккаунт необходимо активировать, вы отправили вам на почту письмо активации. 😉'
            ? result = {error: 'activating'}
            : ''
        });
      return result;
    },
    async logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      axios.post(`/api/auth/logout`, {refresh: localStorage.getItem('refresh')})
      localStorage.removeItem('refresh');
      axios.defaults.headers.common['Authorization'] = null;
      axios.defaults.headers.common['Refresh'] = null;
    },
    async session({ commit }, token) {
      let result = null;
      await axios
        .post(`/api/auth/session`, {}, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => {
          result = response;
          commit;
        })
        .catch((errors) => {
          result = errors;
        });
        return result;
    },
    async getAuthUser({dispatch, commit }, params) {
      let user = null;
      await axios
        .post(`/api/user`, params )
        .then((response) => {
          user = response.data;
          commit('setUserAuth', user);
        })
        .catch((error) => {
          if (error.response.data !== 'You token is not verified!' || error.response.data !== 'Your refresh is dead!') {
            dispatch('addError', { message: error.response.data });}
        });
      return user;
    },
    async editAuthUser({ commit }, params) {
      commit('editAuthUser', params);
    },
    async setAuthUser({ commit }, user) {
      commit('setUserAuth', user);
    },
    async newUser({ dispatch, commit }, data) {
      let result = null;
      await axios
        .post(`/api/auth/registration`, data)
        .then((response) => {
          result = response.data
          commit;
        })
        .catch((error) => {
          if (error.response.data !== 'You token is not verified!' || error.response.data !== 'Your refresh is dead!') {
dispatch('addError', { message: error.response.data });}
        });
      return result;
    },
    async editUser({dispatch, commit }, params) {
      await axios
        .post(`/api/profile/edit`, params)
        .then(() => {
          commit('editAuthUser', {key: params.options.type, val: params.options.value})
        })
        .catch((error) => {
          if (error.response.data !== 'You token is not verified!' || error.response.data !== 'Your refresh is dead!') {
dispatch('addError', { message: error.response.data });}
        });
    }
  },
  mutations: {
    deleteNotifsByChat(s, chat) {
      s.user_notifications.messages.rows = s.user_notifications.messages.rows.filter(
        (message) => message.chat !== chat.id
      );
    },
    editAuthUser(s, params) {
      s.userAuth ? s.userAuth[params.key] = params.val : '';
    },
    setUserAuth(s, user) {
      s.userAuth = user;
    },
    setNotifications(s, notifications) {
      s.user_notifications = notifications;
    },
    clearNotifications(s) {
      s.user_notifications.all = null;
    },
    addMessageNotification(s, notification) {
      s.user_notifications.messages.all.rows.push(notification);
    },
  },
  getters: {
    getAuthUser: (s) => s.userAuth,
    getUserNotifications: (s) => s.user_notifications,
  },
};
